import { useState, useEffect, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { workersAPI, shipmentsAPI, fleetAPI } from '../services/api'
import './LogisticsDashboard.css'

const LOGISTICS_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD || ''  // deprecated — use main /admin
const LOGISTICS_AUTH_KEY = 'logistics_auth'
const LANG_KEY = 'dashboard_lang'

const translations = {
  en: {
    groupeOuambo: 'Groupe Ouambo',
    logisticsDashboard: 'Logistics Dashboard',
    password: 'Password',
    enterPassword: 'Enter logistics password',
    login: 'Login',
    backToWebsite: '← Back to website',
    overview: 'Overview',
    shipments: 'Shipments',
    fleet: 'Fleet',
    workers: 'Workers',
    adminDashboard: 'Admin Dashboard →',
    publicSite: '← Public Site',
    logout: 'Logout',
    logistics: 'Logistics',
    logisticsOverview: 'Logistics Overview',
    overviewSub: 'Real-time operations status for Groupe Ouambo logistics.',
    inTransit: 'In Transit',
    ofTotal: 'of',
    totalLabel: 'total',
    delivered: 'Delivered',
    completed: 'completed',
    pending: 'Pending',
    awaitingDispatch: 'awaiting dispatch',
    fleetAvailable: 'Fleet Available',
    vehicles: 'vehicles',
    recentShipments: 'Recent Shipments',
    viewAll: 'View all →',
    noShipments: 'No shipments yet.',
    reference: 'Reference',
    originDest: 'Origin → Destination',
    client: 'Client',
    status: 'Status',
    logisticsTeam: 'Logistics Team',
    noLogisticsWorkers: 'No logistics workers added yet.',
    addViaAdmin: 'Add via Admin →',
    shipmentManagement: 'Shipment Management',
    trackShipments: 'Track and manage all active and past shipments.',
    addNewShipment: '+ Add New Shipment',
    referenceNo: 'Reference No.',
    origin: 'Origin',
    destination: 'Destination',
    cargoDesc: 'Cargo Description',
    weightVolume: 'Weight / Volume',
    assignedDriver: 'Assigned Driver',
    selectDriver: '— Select driver —',
    estimatedDate: 'Estimated Delivery Date',
    initialStatus: 'Initial Status',
    createShipment: 'Create Shipment',
    cancel: 'Cancel',
    allShipments: 'All Shipments',
    searchShipments: 'Search by ref, route, client...',
    noShipmentsYet: 'No shipments yet. Add one above.',
    noResults: 'No results found.',
    origin2: 'Origin',
    destination2: 'Destination',
    cargo: 'Cargo',
    driver: 'Driver',
    estDate: 'Est. Date',
    actions: 'Actions',
    remove: 'Remove',
    fleetManagement: 'Fleet Management',
    trackVehicles: 'Track all vehicles and their operational status.',
    addVehicle: 'Add Vehicle',
    plateNumber: 'Plate Number',
    vehicleType: 'Vehicle Type',
    modelMake: 'Model / Make',
    capacity: 'Capacity',
    regionBase: 'Region / Base',
    addVehicleBtn: 'Add Vehicle',
    noVehicles: 'No vehicles in fleet yet. Add one above.',
    logisticsTeamTitle: 'Logistics Team',
    workersAssigned: 'Workers assigned to the logistics department.',
    noLogisticsWorkersFound: 'No logistics workers found.',
    addWorkersVia: 'Add workers via the Admin Dashboard →',
    toAddRemove: 'To add or remove workers, use the',
    adminDashboardLink: 'Admin Dashboard'
  },
  fr: {
    groupeOuambo: 'Groupe Ouambo',
    logisticsDashboard: 'Tableau de bord Logistique',
    password: 'Mot de passe',
    enterPassword: 'Entrez le mot de passe logistique',
    login: 'Se connecter',
    backToWebsite: '← Retour au site',
    overview: 'Aperçu',
    shipments: 'Expéditions',
    fleet: 'Flotte',
    workers: 'Employés',
    adminDashboard: 'Tableau de bord Admin →',
    publicSite: '← Site public',
    logout: 'Déconnexion',
    logistics: 'Logistique',
    logisticsOverview: 'Aperçu Logistique',
    overviewSub: 'Statut des opérations en temps réel pour la logistique de Groupe Ouambo.',
    inTransit: 'En transit',
    ofTotal: 'sur',
    totalLabel: 'total',
    delivered: 'Livrées',
    completed: 'terminées',
    pending: 'En attente',
    awaitingDispatch: 'en attente d\'expédition',
    fleetAvailable: 'Flotte disponible',
    vehicles: 'véhicules',
    recentShipments: 'Expéditions récentes',
    viewAll: 'Voir tout →',
    noShipments: 'Aucune expédition pour l\'instant.',
    reference: 'Référence',
    originDest: 'Origine → Destination',
    client: 'Client',
    status: 'Statut',
    logisticsTeam: 'Équipe logistique',
    noLogisticsWorkers: 'Aucun employé logistique ajouté pour l\'instant.',
    addViaAdmin: 'Ajouter via Admin →',
    shipmentManagement: 'Gestion des expéditions',
    trackShipments: 'Suivez et gérez toutes les expéditions actives et passées.',
    addNewShipment: '+ Ajouter une expédition',
    referenceNo: 'N° de référence',
    origin: 'Origine',
    destination: 'Destination',
    cargoDesc: 'Description du fret',
    weightVolume: 'Poids / Volume',
    assignedDriver: 'Chauffeur assigné',
    selectDriver: '— Sélectionner un chauffeur —',
    estimatedDate: 'Date de livraison estimée',
    initialStatus: 'Statut initial',
    createShipment: 'Créer l\'expédition',
    cancel: 'Annuler',
    allShipments: 'Toutes les expéditions',
    searchShipments: 'Rechercher par réf., route, client...',
    noShipmentsYet: 'Aucune expédition. Ajoutez-en une ci-dessus.',
    noResults: 'Aucun résultat.',
    origin2: 'Origine',
    destination2: 'Destination',
    cargo: 'Fret',
    driver: 'Chauffeur',
    estDate: 'Date est.',
    actions: 'Actions',
    remove: 'Supprimer',
    fleetManagement: 'Gestion de la flotte',
    trackVehicles: 'Suivez tous les véhicules et leur statut opérationnel.',
    addVehicle: 'Ajouter un véhicule',
    plateNumber: 'Numéro de plaque',
    vehicleType: 'Type de véhicule',
    modelMake: 'Modèle / Marque',
    capacity: 'Capacité',
    regionBase: 'Région / Base',
    addVehicleBtn: 'Ajouter un véhicule',
    noVehicles: 'Aucun véhicule dans la flotte. Ajoutez-en un ci-dessus.',
    logisticsTeamTitle: 'Équipe logistique',
    workersAssigned: 'Employés assignés au département logistique.',
    noLogisticsWorkersFound: 'Aucun employé logistique trouvé.',
    addWorkersVia: 'Ajouter des employés via le tableau de bord Admin →',
    toAddRemove: 'Pour ajouter ou supprimer des employés, utilisez le',
    adminDashboardLink: 'Tableau de bord Admin'
  }
}



const EMPTY_SHIPMENT = {
  reference: '',
  origin: '',
  destination: '',
  cargo: '',
  weight: '',
  status: 'pending',
  client: '',
  driver: '',
  estimatedDate: ''
}

const EMPTY_VEHICLE = {
  plateNumber: '',
  type: 'truck',
  model: '',
  capacity: '',
  region: '',
  status: 'available'
}

const STATUS_COLORS = {
  pending:    { bg: '#fffbeb', color: '#d97706' },
  'in-transit': { bg: '#eff6ff', color: '#2563eb' },
  delivered:  { bg: '#f0fdf4', color: '#16a34a' },
  delayed:    { bg: '#fef2f2', color: '#dc2626' },
  available:  { bg: '#f0fdf4', color: '#16a34a' },
  'in-use':   { bg: '#eff6ff', color: '#2563eb' },
  maintenance:{ bg: '#fef2f2', color: '#dc2626' }
}

function StatusBadge({ status }) {
  const s = STATUS_COLORS[status] || { bg: '#f3f4f6', color: '#6b7280' }
  return (
    <span
      className="log-badge"
      style={{ background: s.bg, color: s.color }}
    >
      {status}
    </span>
  )
}

function LogisticsDashboard() {
  const [lang, setLang] = useState(() => localStorage.getItem(LANG_KEY) || 'fr')
  const t = translations[lang]

  const [isAuthenticated, setIsAuthenticated] = useState(() => localStorage.getItem(LOGISTICS_AUTH_KEY) === 'true')
  const [password, setPassword] = useState('')
  const [authError, setAuthError] = useState('')
  const [activeTab, setActiveTab] = useState('overview')
  const [sidebarOpen, setSidebarOpen] = useState(false)

  // Shipments
  const [shipments, setShipments] = useState([])
  const [shipmentForm, setShipmentForm] = useState({ ...EMPTY_SHIPMENT })
  const [shipmentStatus, setShipmentStatus] = useState('')
  const [shipmentSearch, setShipmentSearch] = useState('')
  const [showAddShipment, setShowAddShipment] = useState(false)

  // Fleet
  const [fleet, setFleet] = useState([])
  const [vehicleForm, setVehicleForm] = useState({ ...EMPTY_VEHICLE })
  const [vehicleStatus, setVehicleStatus] = useState('')

  // Workers
  const [workers, setWorkers] = useState([])

  useEffect(() => { workersAPI.getAll().then(setWorkers).catch(console.error) }, [])
  useEffect(() => { shipmentsAPI.getAll().then(setShipments).catch(console.error) }, [])
  useEffect(() => { fleetAPI.getAll().then(setFleet).catch(console.error) }, [])

  // Workers (read from API)
  const logisticsWorkers = useMemo(() =>
    workers.filter(w => w.department === 'logistics'),
    [workers]
  )

  // Filtered shipments
  const filteredShipments = useMemo(() => {
    if (!shipmentSearch.trim()) return shipments
    const q = shipmentSearch.toLowerCase()
    return shipments.filter(s =>
      s.reference.toLowerCase().includes(q) ||
      s.origin.toLowerCase().includes(q) ||
      s.destination.toLowerCase().includes(q) ||
      s.client.toLowerCase().includes(q) ||
      s.status.toLowerCase().includes(q)
    )
  }, [shipments, shipmentSearch])

  // Stats
  const stats = useMemo(() => ({
    total: shipments.length,
    inTransit: shipments.filter(s => s.status === 'in-transit').length,
    delivered: shipments.filter(s => s.status === 'delivered').length,
    pending: shipments.filter(s => s.status === 'pending').length,
    fleetAvailable: fleet.filter(v => v.status === 'available').length,
    fleetTotal: fleet.length
  }), [shipments, fleet])

  // ─── Auth ──────────────────────────────────────────────────────
  const handleLogin = (e) => {
    e.preventDefault()
    if (password === LOGISTICS_PASSWORD) {
      setIsAuthenticated(true)
      localStorage.setItem(LOGISTICS_AUTH_KEY, 'true')
      setAuthError('')
    } else {
      setAuthError('Invalid password. Please try again.')
    }
  }

  // ─── Shipments ─────────────────────────────────────────────────
  const handleAddShipment = async (e) => {
    e.preventDefault()
    const { origin, destination } = shipmentForm
    if (!origin.trim() || !destination.trim()) { setShipmentStatus('Origin and destination are required.'); return }
    try {
      const created = await shipmentsAPI.create(shipmentForm)
      setShipments(prev => [...prev, created])
      setShipmentForm({ ...EMPTY_SHIPMENT })
      setShipmentStatus(`Shipment ${created.reference} created.`)
      setShowAddShipment(false)
    } catch (err) { setShipmentStatus('Error: ' + err.message) }
  }

  const handleUpdateShipmentStatus = async (id, newStatus) => {
    try {
      const updated = await shipmentsAPI.update(id, { status: newStatus })
      setShipments(prev => prev.map(s => s.id === id ? updated : s))
    } catch (err) { console.error(err) }
  }

  const handleDeleteShipment = async (id) => {
    try { await shipmentsAPI.delete(id); setShipments(prev => prev.filter(s => s.id !== id)) } catch (err) { console.error(err) }
  }

  // ─── Fleet ─────────────────────────────────────────────────────
  const handleAddVehicle = async (e) => {
    e.preventDefault()
    if (!vehicleForm.plateNumber.trim()) { setVehicleStatus('Plate number is required.'); return }
    try {
      const created = await fleetAPI.create(vehicleForm)
      setFleet(prev => [...prev, created])
      setVehicleForm({ ...EMPTY_VEHICLE })
      setVehicleStatus(`Vehicle ${created.plateNumber} added.`)
    } catch (err) { setVehicleStatus('Error: ' + err.message) }
  }

  const handleVehicleStatusChange = async (id, newStatus) => {
    try {
      const updated = await fleetAPI.update(id, { status: newStatus })
      setFleet(prev => prev.map(v => v.id === id ? updated : v))
    } catch (err) { console.error(err) }
  }

  const handleDeleteVehicle = async (id) => {
    try { await fleetAPI.delete(id); setFleet(prev => prev.filter(v => v.id !== id)) } catch (err) { console.error(err) }
  }

  const navigate = (tab) => {
    setActiveTab(tab)
    setSidebarOpen(false)
  }

  const navItems = [
    { key: 'overview',  icon: '📊', label: t.overview },
    { key: 'shipments', icon: '🚢', label: t.shipments, badge: stats.inTransit || null },
    { key: 'fleet',     icon: '🚛', label: t.fleet,     badge: stats.fleetTotal || null },
    { key: 'workers',   icon: '👥', label: t.workers,   badge: logisticsWorkers.length || null }
  ]

  // ─── Login Screen ──────────────────────────────────────────────
  if (!isAuthenticated) {
    return (
      <div className="log-login-screen">
        <div className="log-login-card">
          <div className="log-login-logo">
            <span className="log-login-icon">🚚</span>
            <h1>{t.groupeOuambo}</h1>
            <p>{t.logisticsDashboard}</p>
          </div>
          <div className="log-lang-toggle" style={{ marginBottom: '-4px' }}>
            <button type="button" className={lang === 'fr' ? 'active' : ''} onClick={() => { const n = 'fr'; localStorage.setItem(LANG_KEY, n); setLang(n) }}>FR</button>
            <button type="button" className={lang === 'en' ? 'active' : ''} onClick={() => { const n = 'en'; localStorage.setItem(LANG_KEY, n); setLang(n) }}>EN</button>
          </div>
          <form className="log-login-form" onSubmit={handleLogin}>
            <label>
              {t.password}
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder={t.enterPassword}
                autoFocus
                required
              />
            </label>
            {authError && <p className="log-login-error">{authError}</p>}
            <button className="log-login-btn" type="submit">{t.login}</button>
          </form>
          <Link className="log-login-back" to="/">{t.backToWebsite}</Link>
        </div>
      </div>
    )
  }

  return (
    <div className="log-layout">
      {sidebarOpen && (
        <div className="log-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* Sidebar */}
      <aside className={`log-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="log-sidebar-brand">
          <span className="log-brand-icon">🚚</span>
          <div>
            <span className="log-brand-name">G.O Logistics</span>
            <span className="log-brand-sub">Operations Center</span>
          </div>
          <button className="log-sidebar-close" onClick={() => setSidebarOpen(false)}>×</button>
        </div>

        <nav className="log-nav">
          {navItems.map(item => (
            <button
              key={item.key}
              className={`log-nav-item ${activeTab === item.key ? 'active' : ''}`}
              onClick={() => navigate(item.key)}
            >
              <span className="log-nav-icon">{item.icon}</span>
              <span className="log-nav-label">{item.label}</span>
              {item.badge ? <span className="log-nav-badge">{item.badge}</span> : null}
            </button>
          ))}
        </nav>

        <div className="log-sidebar-footer">
          <Link className="log-sidebar-link" to="/admin">{t.adminDashboard}</Link>
          <Link className="log-sidebar-link" to="/">{t.publicSite}</Link>
          <button
            className="log-logout-btn"
            onClick={() => { setIsAuthenticated(false); localStorage.removeItem(LOGISTICS_AUTH_KEY) }}
          >
            {t.logout}
          </button>
        </div>
      </aside>

      {/* Main */}
      <div className="log-main">
        {/* Topbar */}
        <header className="log-topbar">
          <button className="log-menu-btn" onClick={() => setSidebarOpen(true)}>☰</button>
          <div className="log-topbar-title">
            {navItems.find(n => n.key === activeTab)?.icon}{' '}
            {navItems.find(n => n.key === activeTab)?.label}
          </div>
          <div className="log-topbar-actions">
            <span className="log-topbar-user">{t.logistics}</span>
            <div className="log-lang-toggle">
              <button className={lang === 'fr' ? 'active' : ''} onClick={() => setLang(l => { const n = l === 'fr' ? 'en' : 'fr'; localStorage.setItem(LANG_KEY, n); return n })}>FR</button>
              <button className={lang === 'en' ? 'active' : ''} onClick={() => setLang(l => { const n = l === 'en' ? 'fr' : 'en'; localStorage.setItem(LANG_KEY, n); return n })}>EN</button>
            </div>
            <button className="log-logout-sm" onClick={() => { setIsAuthenticated(false); localStorage.removeItem(LOGISTICS_AUTH_KEY) }}>{t.logout}</button>
          </div>
        </header>

        <div className="log-content">

          {/* ── OVERVIEW ─────────────────────────────────────── */}
          {activeTab === 'overview' && (
            <div className="log-section">
              <div className="log-section-header">
                <h2>{t.logisticsOverview}</h2>
                <p>{t.overviewSub}</p>
              </div>

              <div className="log-stats-grid">
                <div className="log-stat-card blue">
                  <div className="log-stat-icon">🚢</div>
                  <div>
                    <p className="log-stat-label">{t.inTransit}</p>
                    <p className="log-stat-value">{stats.inTransit}</p>
                    <p className="log-stat-sub">{t.ofTotal} {stats.total} {t.totalLabel}</p>
                  </div>
                </div>
                <div className="log-stat-card green">
                  <div className="log-stat-icon">✅</div>
                  <div>
                    <p className="log-stat-label">{t.delivered}</p>
                    <p className="log-stat-value">{stats.delivered}</p>
                    <p className="log-stat-sub">{t.completed}</p>
                  </div>
                </div>
                <div className="log-stat-card orange">
                  <div className="log-stat-icon">⏳</div>
                  <div>
                    <p className="log-stat-label">{t.pending}</p>
                    <p className="log-stat-value">{stats.pending}</p>
                    <p className="log-stat-sub">{t.awaitingDispatch}</p>
                  </div>
                </div>
                <div className="log-stat-card teal">
                  <div className="log-stat-icon">🚛</div>
                  <div>
                    <p className="log-stat-label">{t.fleetAvailable}</p>
                    <p className="log-stat-value">{stats.fleetAvailable}</p>
                    <p className="log-stat-sub">{t.ofTotal} {stats.fleetTotal} {t.vehicles}</p>
                  </div>
                </div>
              </div>

              {/* Recent Shipments */}
              <div className="log-overview-card">
                <div className="log-overview-card-header">
                  <h3>{t.recentShipments}</h3>
                  <button className="log-link-btn" onClick={() => navigate('shipments')}>{t.viewAll}</button>
                </div>
                {shipments.length === 0 ? (
                  <p className="log-empty-msg">{t.noShipments}</p>
                ) : (
                  <div className="log-table-wrap">
                    <table className="log-table">
                      <thead>
                        <tr>
                          <th>{t.reference}</th>
                          <th>{t.originDest}</th>
                          <th>{t.client}</th>
                          <th>{t.status}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {shipments.slice(-5).reverse().map(s => (
                          <tr key={s.id}>
                            <td className="log-ref">{s.reference}</td>
                            <td>{s.origin} → {s.destination}</td>
                            <td>{s.client || '—'}</td>
                            <td><StatusBadge status={s.status} /></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              {/* Workers summary */}
              <div className="log-overview-card">
                <div className="log-overview-card-header">
                  <h3>{t.logisticsTeam}</h3>
                  <button className="log-link-btn" onClick={() => navigate('workers')}>{t.viewAll}</button>
                </div>
                {logisticsWorkers.length === 0 ? (
                  <p className="log-empty-msg">{t.noLogisticsWorkers} <Link to="/admin">{t.addViaAdmin}</Link></p>
                ) : (
                  <div className="log-workers-mini">
                    {logisticsWorkers.slice(0, 6).map(w => (
                      <div key={w.id} className="log-worker-chip">
                        <span className="log-worker-avatar">{w.name[0]?.toUpperCase()}</span>
                        <div>
                          <span className="log-worker-name">{w.name}</span>
                          <span className="log-worker-role">{w.role}</span>
                        </div>
                        <span className={`log-status-dot ${w.status}`}></span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* ── SHIPMENTS ────────────────────────────────────── */}
          {activeTab === 'shipments' && (
            <div className="log-section">
              <div className="log-section-header">
                <h2>{t.shipmentManagement}</h2>
                <p>{t.trackShipments}</p>
              </div>

              {/* Add Shipment */}
              <div className="log-card">
                <div
                  className="log-card-toggle"
                  onClick={() => setShowAddShipment(!showAddShipment)}
                >
                  <h3>{t.addNewShipment}</h3>
                  <span>{showAddShipment ? '▲' : '▼'}</span>
                </div>

                {showAddShipment && (
                  <form className="log-form" onSubmit={handleAddShipment}>
                    <div className="log-form-row">
                      <label>
                        {t.referenceNo}
                        <input
                          type="text"
                          value={shipmentForm.reference}
                          onChange={e => setShipmentForm(p => ({ ...p, reference: e.target.value }))}
                          placeholder="GO-2024-001 (auto-generated if empty)"
                        />
                      </label>
                      <label>
                        {t.client}
                        <input
                          type="text"
                          value={shipmentForm.client}
                          onChange={e => setShipmentForm(p => ({ ...p, client: e.target.value }))}
                          placeholder="Client name or company"
                        />
                      </label>
                    </div>
                    <div className="log-form-row">
                      <label>
                        {t.origin} <span className="log-required">*</span>
                        <input
                          type="text"
                          value={shipmentForm.origin}
                          onChange={e => setShipmentForm(p => ({ ...p, origin: e.target.value }))}
                          placeholder="Yaounde, Cameroun"
                        />
                      </label>
                      <label>
                        {t.destination} <span className="log-required">*</span>
                        <input
                          type="text"
                          value={shipmentForm.destination}
                          onChange={e => setShipmentForm(p => ({ ...p, destination: e.target.value }))}
                          placeholder="Bangui, RCA"
                        />
                      </label>
                    </div>
                    <div className="log-form-row">
                      <label>
                        {t.cargoDesc}
                        <input
                          type="text"
                          value={shipmentForm.cargo}
                          onChange={e => setShipmentForm(p => ({ ...p, cargo: e.target.value }))}
                          placeholder="IT Equipment, 5 units"
                        />
                      </label>
                      <label>
                        {t.weightVolume}
                        <input
                          type="text"
                          value={shipmentForm.weight}
                          onChange={e => setShipmentForm(p => ({ ...p, weight: e.target.value }))}
                          placeholder="500 kg / 2 CBM"
                        />
                      </label>
                    </div>
                    <div className="log-form-row">
                      <label>
                        {t.assignedDriver}
                        <select
                          value={shipmentForm.driver}
                          onChange={e => setShipmentForm(p => ({ ...p, driver: e.target.value }))}
                        >
                          <option value="">{t.selectDriver}</option>
                          {logisticsWorkers.map(w => (
                            <option key={w.id} value={w.name}>{w.name} ({w.role})</option>
                          ))}
                        </select>
                      </label>
                      <label>
                        {t.estimatedDate}
                        <input
                          type="date"
                          value={shipmentForm.estimatedDate}
                          onChange={e => setShipmentForm(p => ({ ...p, estimatedDate: e.target.value }))}
                        />
                      </label>
                    </div>
                    <label>
                      {t.initialStatus}
                      <select
                        value={shipmentForm.status}
                        onChange={e => setShipmentForm(p => ({ ...p, status: e.target.value }))}
                      >
                        <option value="pending">Pending</option>
                        <option value="in-transit">In Transit</option>
                        <option value="delivered">Delivered</option>
                        <option value="delayed">Delayed</option>
                      </select>
                    </label>
                    <div className="log-form-actions">
                      <button className="log-btn primary" type="submit">{t.createShipment}</button>
                      <button className="log-btn secondary" type="button" onClick={() => setShowAddShipment(false)}>{t.cancel}</button>
                      {shipmentStatus && <span className="log-status-msg">{shipmentStatus}</span>}
                    </div>
                  </form>
                )}
              </div>

              {/* Shipments Table */}
              <div className="log-card">
                <div className="log-table-toolbar">
                  <h3>{t.allShipments} ({shipments.length})</h3>
                  <input
                    className="log-search"
                    type="search"
                    placeholder={t.searchShipments}
                    value={shipmentSearch}
                    onChange={e => setShipmentSearch(e.target.value)}
                  />
                </div>

                {filteredShipments.length === 0 ? (
                  <div className="log-empty-state">
                    <span>🚢</span>
                    <p>{shipments.length === 0 ? t.noShipmentsYet : t.noResults}</p>
                  </div>
                ) : (
                  <div className="log-table-wrap">
                    <table className="log-table">
                      <thead>
                        <tr>
                          <th>{t.reference}</th>
                          <th>{t.origin2}</th>
                          <th>{t.destination2}</th>
                          <th>{t.cargo}</th>
                          <th>{t.client}</th>
                          <th>{t.driver}</th>
                          <th>{t.estDate}</th>
                          <th>{t.status}</th>
                          <th>{t.actions}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredShipments.map(s => (
                          <tr key={s.id}>
                            <td className="log-ref">{s.reference}</td>
                            <td>{s.origin}</td>
                            <td>{s.destination}</td>
                            <td className="log-muted">{s.cargo || '—'}</td>
                            <td>{s.client || '—'}</td>
                            <td>{s.driver || '—'}</td>
                            <td className="log-muted">
                              {s.estimatedDate ? new Date(s.estimatedDate).toLocaleDateString() : '—'}
                            </td>
                            <td>
                              <select
                                className="log-status-select"
                                value={s.status}
                                onChange={e => handleUpdateShipmentStatus(s.id, e.target.value)}
                              >
                                <option value="pending">Pending</option>
                                <option value="in-transit">In Transit</option>
                                <option value="delivered">Delivered</option>
                                <option value="delayed">Delayed</option>
                              </select>
                            </td>
                            <td>
                              <button
                                className="log-delete-btn"
                                onClick={() => handleDeleteShipment(s.id)}
                              >
                                {t.remove}
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* ── FLEET ────────────────────────────────────────── */}
          {activeTab === 'fleet' && (
            <div className="log-section">
              <div className="log-section-header">
                <h2>{t.fleetManagement}</h2>
                <p>{t.trackVehicles}</p>
              </div>

              {/* Add Vehicle Form */}
              <div className="log-card">
                <h3>{t.addVehicle}</h3>
                <form className="log-form" onSubmit={handleAddVehicle}>
                  <div className="log-form-row">
                    <label>
                      {t.plateNumber} <span className="log-required">*</span>
                      <input
                        type="text"
                        value={vehicleForm.plateNumber}
                        onChange={e => setVehicleForm(p => ({ ...p, plateNumber: e.target.value }))}
                        placeholder="CM-1234-AB"
                      />
                    </label>
                    <label>
                      {t.vehicleType}
                      <select
                        value={vehicleForm.type}
                        onChange={e => setVehicleForm(p => ({ ...p, type: e.target.value }))}
                      >
                        <option value="truck">Truck</option>
                        <option value="feeder">Feeder Truck</option>
                        <option value="van">Van</option>
                        <option value="container">Container</option>
                        <option value="flatbed">Flatbed</option>
                        <option value="tanker">Tanker</option>
                        <option value="motorcycle">Motorcycle</option>
                      </select>
                    </label>
                  </div>
                  <div className="log-form-row">
                    <label>
                      {t.modelMake}
                      <input
                        type="text"
                        value={vehicleForm.model}
                        onChange={e => setVehicleForm(p => ({ ...p, model: e.target.value }))}
                        placeholder="Mercedes Actros 2019"
                      />
                    </label>
                    <label>
                      {t.capacity}
                      <input
                        type="text"
                        value={vehicleForm.capacity}
                        onChange={e => setVehicleForm(p => ({ ...p, capacity: e.target.value }))}
                        placeholder="10 tons / 30 CBM"
                      />
                    </label>
                  </div>
                  <div className="log-form-row">
                    <label>
                      {t.regionBase}
                      <input
                        type="text"
                        value={vehicleForm.region}
                        onChange={e => setVehicleForm(p => ({ ...p, region: e.target.value }))}
                        placeholder="Cameroun"
                      />
                    </label>
                    <label>
                      {t.status}
                      <select
                        value={vehicleForm.status}
                        onChange={e => setVehicleForm(p => ({ ...p, status: e.target.value }))}
                      >
                        <option value="available">Available</option>
                        <option value="in-use">In Use</option>
                        <option value="maintenance">Maintenance</option>
                      </select>
                    </label>
                  </div>
                  <div className="log-form-actions">
                    <button className="log-btn primary" type="submit">{t.addVehicleBtn}</button>
                    {vehicleStatus && <span className="log-status-msg">{vehicleStatus}</span>}
                  </div>
                </form>
              </div>

              {/* Fleet Grid */}
              {fleet.length === 0 ? (
                <div className="log-empty-state">
                  <span>🚛</span>
                  <p>{t.noVehicles}</p>
                </div>
              ) : (
                <div className="log-fleet-grid">
                  {fleet.map(v => (
                    <div key={v.id} className="log-fleet-card">
                      <div className="log-fleet-card-header">
                        <span className="log-fleet-icon">
                          {v.type === 'truck' ? '🚛' : v.type === 'feeder' ? '🚚' : v.type === 'van' ? '🚐' : v.type === 'motorcycle' ? '🏍️' : '🚢'}
                        </span>
                        <div>
                          <p className="log-fleet-plate">{v.plateNumber}</p>
                          <p className="log-fleet-type">{v.type}</p>
                        </div>
                        <button
                          className="log-delete-icon"
                          onClick={() => handleDeleteVehicle(v.id)}
                          title="Remove vehicle"
                        >
                          ×
                        </button>
                      </div>
                      <div className="log-fleet-details">
                        {v.model && <p><strong>Model:</strong> {v.model}</p>}
                        {v.capacity && <p><strong>Capacity:</strong> {v.capacity}</p>}
                        {v.region && <p><strong>Region:</strong> {v.region}</p>}
                      </div>
                      <div className="log-fleet-footer">
                        <select
                          className="log-status-select"
                          value={v.status}
                          onChange={e => handleVehicleStatusChange(v.id, e.target.value)}
                        >
                          <option value="available">Available</option>
                          <option value="in-use">In Use</option>
                          <option value="maintenance">Maintenance</option>
                        </select>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* ── WORKERS ──────────────────────────────────────── */}
          {activeTab === 'workers' && (
            <div className="log-section">
              <div className="log-section-header">
                <h2>{t.logisticsTeamTitle}</h2>
                <p>{t.workersAssigned}</p>
              </div>

              {logisticsWorkers.length === 0 ? (
                <div className="log-empty-state">
                  <span>👥</span>
                  <p>
                    {t.noLogisticsWorkersFound}{' '}
                    <Link to="/admin" className="log-link">{t.addWorkersVia}</Link>
                  </p>
                </div>
              ) : (
                <div className="log-workers-grid">
                  {logisticsWorkers.map(w => (
                    <div key={w.id} className="log-worker-card">
                      <div className="log-worker-card-header">
                        <span className="log-worker-card-avatar">{w.name[0]?.toUpperCase()}</span>
                        <span className={`log-status-dot ${w.status}`}></span>
                      </div>
                      <h4 className="log-worker-card-name">{w.name}</h4>
                      <p className="log-worker-card-role">{w.role}</p>
                      <div className="log-worker-card-details">
                        {w.region && <p>📍 {w.region}</p>}
                        {w.email && <p>✉️ <a href={`mailto:${w.email}`}>{w.email}</a></p>}
                        {w.phone && <p>📞 {w.phone}</p>}
                      </div>
                      <span className={`log-worker-status-badge ${w.status}`}>{w.status}</span>
                    </div>
                  ))}
                </div>
              )}

              {logisticsWorkers.length > 0 && (
                <p className="log-note">
                  {t.toAddRemove} <Link to="/admin">{t.adminDashboardLink}</Link>.
                </p>
              )}
            </div>
          )}

        </div>
      </div>
    </div>
  )
}

export default LogisticsDashboard
